export function array2map(arr: string[]): Dictionary<boolean> {
  return arr.reduce((memo: Dictionary<boolean>, id: string) => {
    memo[id] = true;
    return memo;
  }, {});
}
